import React from 'react'
import Layout from '../components/Layout'
import { graphql, useStaticQuery } from "gatsby"
import CourseCard from '../components/columns/CourseCard'

const Courses = () => {
    const coursesQuery = useStaticQuery(graphql`
        query {
            allCoursesJson {
                edges {
                    node {
                        id
                        description
                        image
                        name
                        kitLink
                        details
                        price
                    }
                }
            }
        }
    `)

    const courses = coursesQuery.allCoursesJson.edges

    const CourseList = () => {
        return (
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: '2rem',
                    width: '100%',
                }}
            >
                {courses.map((item) => (
                    <CourseCard
                        key={item.node.id}
                        id={item.node.id}
                        image={item.node.image}
                        price={item.node.price}
                        name={item.node.name}
                        description={item.node.description}
                        details={item.node.details}
                        kitLink={item.node.kitLink}
                    />
                ))}
            </div>
        )
    }

    return (
        <Layout
            langKey="en"
            slug="/"
        >
            <div
                className="container center"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2rem",
                    marginTop: "8rem",
                    marginBottom: "8rem"
                }}
            >
                <section className="hero">
                    <div className="hero-body">
                        <p className="title">Courses</p>
                        <p className="subtitle">
                            Our courses are designed to provide learners with practical
                            knowledge and skills across a wide range of topics. Whether
                            you're a beginner looking to build a strong foundation or a
                            professional aiming to enhance your expertise, our programs
                            offer flexible learning options to suit your goals.
                        </p>
                    </div>
                </section>

                <CourseList />
            </div>
        </Layout>
    )
}

export default Courses